// Scrollmenu is is fixed to the top of the window when the page is scrolled
// over a threshold.  It is patched into a div with id 'topmenuwrapper'
// which is created by the ScrollMenu fuction.  When the menu
// is not being show the contents of the div are deleted.
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { patch, elementOpen, elementClose, elementVoid, text } from 'incremental-dom';
// import Sizzle from 'sizzle';
import { isNil } from '../../utils';
import { linkClick, scrollObservable } from '../../rxjs';
// import { headMenuFormattedContent } from '../headmenu';
// import { hoverMenuContent} from '../src/components/headmenu';
// import { topDropMenuToggle } from '../src/components/headmenu/topdropmenu';
// import { sideTopMenuToggle } from '../src/components/headmenu/sidemenu';
import { MenuType } from '../../enums';
// import { formattedSideMenuContent } from '../src/components/headmenu/content';
import { HamburgerIcon } from '../icons/hamburger';
import './scrollmenu.scss';
import { exportedSiteData } from '../../index';
//FIXME:  DRY this up.  If this is imported from headmenu the scss also gets included
var headMenuFormattedContent = function (headMenuContent, currentLocation, shorten, menuType) {
    if (menuType === void 0) { menuType = MenuType.Head; }
    elementOpen('div', null, null, 'id', 'menucontent');
    var displayList = headMenuContent
        .filter(function (m) { return ((shorten === 0) || (currentLocation !== m.link)); }) // shorten:1 cuts just the current link
        .filter(function (m) { return (m.priority > shorten); })
        .map(function (m) { return ({ menuText: m.menuText, link: m.link }); });
    if (displayList.length < 2) {
        // NICE: Could also make this open the menu
        elementOpen('p');
        if (exportedSiteData.pageLabels[currentLocation] !== undefined) {
            text(exportedSiteData.pageLabels[currentLocation]);
        }
        else {
            text(currentLocation.split('/').slice(-1)[0]);
        }
        elementClose('p');
    }
    else {
        elementOpen('ul', null, ['id', menuType === MenuType.Top ? 'mclist-top' : 'mclist-head']);
        displayList.map(function (_a, i) {
            var menuText = _a.menuText, link = _a.link;
            elementOpen('li');
            elementOpen('a', "mc-" + i, null, 'href', link, 'class', currentLocation === link ? 'active-link' : 'other-link', 'onclick', function (event) {
                linkClick(event, link);
            });
            text(menuText);
            elementClose('a');
            elementClose('li');
        });
        elementClose('ul');
    }
    elementClose('div');
};
var transitionTime = 700;
;
var topMenuStore = {
    subShow: false,
    show: false,
    actual: 0,
    shorten: 0
};
var merge = function (b, n) {
    return (__assign(__assign({}, b), n));
};
var ScrollMenu = function (pageChangeObservable, headMenuContent, headerLogo, dropmenu) {
    // console.log(`Creating scroll menu`)
    var smel = document.body.appendChild(document.createElement('div'));
    smel.id = 'topmenuwrapper';
    var sm = Object.create({});
    // sm.render = () => scrollMenu(headMenuContent, headerLogo, dropmenu)
    sm.toggle = function (force) { return topMenuToggle(scrollMenu(headMenuContent, headerLogo, dropmenu), force, window.location.pathname); };
    scrollObservable.subscribe({
        next: function (event) {
            if (window.pageYOffset > 50) { // scrollY not available on IE11
                if (sm.toggle(true) === true) {
                    dropmenu.toggle(false);
                }
            }
            if (window.pageYOffset < 50) {
                sm.toggle(false);
                dropmenu.toggle(false);
            }
        }
    });
    pageChangeObservable.subscribe({
        next: function (page) {
            dropmenu.toggle(false, false);
            if (page.pageBaseChanged) {
                sm.toggle(false);
            }
        }
    });
    return sm;
};
var topMenuShorten = function (by) {
    topMenuStore.shorten = by < 0
        ? 0
        : topMenuStore.shorten > 10
            ? topMenuStore.shorten
            : topMenuStore.shorten + by;
};
var patchElement = function (id) {
    return document.getElementById(id);
};
// let subMenu = false;
// const toggleSubMenu = (currentLocation) => {
//   const wide = document.body.clientWidth>1023;
//   if (!topMenuStore.subShow) {
//       // console.log('showing submenu')
//       topMenuStore.subShow = true;
//       if (wide) {
//           console.log(`Showing top sub menu: ${currentLocation}`)
//           console.log(patchElement('topsubmenu'));
//           patch(patchElement('topsubmenu'), () => {
//               elementOpen('div', null, null, 'class', 'tophovermenu');
//                   hoverMenuContent(currentLocation);
//               elementClose('div');
//           });
//           topDropMenuToggle(true);
//       } else {
//           patch(patchElement('topsidemenu'), () => {
//                   formattedSideMenuContent(currentLocation);
//           });
//           sideTopMenuToggle(true);
//       }
//   } else {
//       // console.log('hiding submenu')
//       if (wide) {
//           topDropMenuToggle(false);
//       } else {
//           sideTopMenuToggle(false);
//       }
//       topMenuStore.subShow = false;
//   }
// };
var afterRepaint = function (f) {
    window.requestAnimationFrame(function () { return window.requestAnimationFrame(f); });
};
var setTopMenuWidth = function (menuContent, loopctr) {
    // NICE: Store the menu length for each screen size in cookies and refesh on page refresh only
    if (loopctr === void 0) { loopctr = 0; }
    var eltop = document.getElementById('mclist-top');
    if (eltop !== null) {
        var el2top = eltop.firstChild;
        if (el2top !== null) {
            // console.log(`menu: ${eltop.offsetLeft} ${el2top.offsetLeft}`);
            if ((el2top.offsetLeft - eltop.offsetLeft) < 10) {
                // console.log(`xMenu Overflowing by: ${(el2top.offsetLeft - eltop.offsetLeft)} loop: ${loopctr}`);
                topMenuShorten(1);
                var topmc = document.getElementById('topmc');
                if (topmc !== null) { // if mclist-top exists this should never happen
                    patch(topmc, function () { return headMenuFormattedContent(menuContent, window.location.pathname, topMenuStore.shorten, MenuType.Top); });
                    // patch(topmc, () => {});
                    afterRepaint(function () { return setTopMenuWidth(menuContent, loopctr + 1); });
                }
                // window.requestAnimationFrame(() => setTopMenuWidth(loopctr+1));
            }
        }
    }
};
var scrollMenu = function (menuContent, siteLogo, dropmenu) { return function (currentLocation) {
    // console.log(`showing top menu: ${currentLocation}`)
    if (dropmenu) {
        dropmenu.toggle(false);
        dropmenu.reset();
    }
    ;
    // const narrow = document.body.clientWidth<1023;
    // const toggleMenu = narrow?() => sideTopMenuToggle(undefined):topDropMenuToggle;
    elementOpen('div', null, null, 'class', 'topmenuouter');
    // 'onmouseover', () => {console.log('menu in'); hoverShow()},
    // 'onmouseout', () => {console.log('top menu outer out'); scheduleClose()}
    // );
    // topsidemenu is the menu which comes in from the side
    // when the hamburger menu is activated on the scroll menu
    elementVoid('div', null, ['id', 'topsidemenu']);
    elementOpen('div', null, null, 'class', 'topmenubar');
    //     'onmouseout', () => {console.log('xtop menu out'); event.stopPropagation();},
    // );
    // 'onmouseover', () => {console.log('x1menu in'); event.stopPropagation()},);
    elementOpen('a', "head-logo", null, 'href', '/', 'class', 'menubarlogolink', 'onclick', function (event) {
        linkClick(event, '/');
    });
    siteLogo();
    elementClose('a');
    elementOpen('div', null, null, 'class', 'content', 'id', 'topmc');
    // 'onmouseover', () => {console.log('x2menu in'); event.stopPropagation()},);
    headMenuFormattedContent(menuContent, currentLocation, topMenuStore.shorten, MenuType.Top);
    elementClose('div');
    // TODO: Can there be only a sidemenu?
    if (dropmenu) {
        HamburgerIcon(function () {
            dropmenu.toggle(undefined, false);
        });
    }
    elementClose('div');
    elementVoid('div', null, ['id', 'topsubmenu']);
    // if (!narrow) {
    //     elementOpen('div', null, null, 'class', 'tophovermenux');
    //         elementOpen('div', null, null, 'class', 'tophovermenu');
    //         // 'onmouseover', () => {
    //         //     clearTimeout(hoverTimeout);
    //         //     event.stopPropagation();
    //         //     });
    //             // hoverMenu();
    //         elementClose('div');
    //     elementClose('div');
    // } else {
    //     elementOpen('div', null, null, 'class', 'sidemenuwrapper', 'id', 'smnick');
    //     // sideMenu();
    //     elementClose('div');
    // }
    elementClose('div');
    // sideMenuKill();
    // console.log('reset top menu')
    // topMenuStore = {
    //     show: false,
    //     actual: 0
    // };
    afterRepaint(function () { return setTopMenuWidth(menuContent, 0); });
}; };
// const topMenuElement = () => {
//     let menuElement = Sizzle('#topmenuwrapper . .topmenubar');
//     return isNil(menuElement) ? undefined : menuElement[0];
// };
// const topMenuWrapper = () => {
//     let menuElement = Sizzle('#topmenuwrapper .topmenuouter');
//     return isNil(menuElement) ? undefined : menuElement[0];
// };
var animateTopMenu = function (showX, menuWidthX, showStartX) {
    var menuElementX = document.getElementById('topmenuwrapper');
    var elementHeight = menuElementX.offsetHeight;
    if ((topMenuStore.show !== showX) || (isNil(menuElementX))) {
        return true; // Show/hide was cancelled or  Menu has been removed
    }
    var progress = (Date.now() - showStartX) / transitionTime;
    if (progress < 0.99) {
        menuElementX.style.top = "-" + elementHeight * (showX ? 1 - progress : progress) + "px";
        topMenuStore = merge(topMenuStore, { actual: showX ? progress : 1 - progress });
        window.requestAnimationFrame(function () { return animateTopMenu(showX, menuWidthX, showStartX); });
    }
    else {
        menuElementX.style.top = showX ? "0px" : "-" + (elementHeight + 1) + "px";
        topMenuStore = merge(topMenuStore, { actual: showX ? 1 : 0 });
        if (!showX) {
            patch(patchElement('topmenuwrapper'), function () { });
        }
    }
};
// Return null means nothing changed, otherwise true/false to show new state
var topMenuToggle = function (topMenuContent, force, currentLocation) {
    if (topMenuStore.show === force) { // Exit if we are already at the force state
        return (null);
    }
    // let menuElementx = Sizzle('#topmenuwrapper .topmenuouter')[0];
    // TODO: make more robust
    var me1 = document.getElementById('topmenuwrapper');
    var menuElementx = me1.getElementsByClassName('topmenuouter');
    // console.log('menuElementx')
    // console.log(menuElementx)
    // return isNil(menuElement) ? undefined : menuElement[0];
    if (menuElementx.length === 0) {
        patch(patchElement('topmenuwrapper'), function () { return topMenuContent(currentLocation); });
    }
    var menuElement = document.getElementById('topmenuwrapper');
    if (!isNil(menuElement)) {
        // console.log('menuElementx patched fff')
        topMenuStore.show = !topMenuStore.show;
        if (!topMenuStore.show) {
            // FIXME:
            // topDropMenuToggle(false); // If the top menu is being hidden, hide the topDrop menu also
            // sideTopMenuToggle(false);
            // topMenuStore.subShow = false;
        }
        var showStart = Date.now() - (topMenuStore.show ? topMenuStore.actual : (1 - topMenuStore.actual)) * transitionTime;
        var currentShow = topMenuStore.show; // Need to fix to current scope
        animateTopMenu(currentShow, menuElement.offsetWidth, showStart);
        return (topMenuStore.show);
    }
    return (null);
};
var topMenuKill = function () {
    topMenuStore = {
        subShow: false,
        show: false,
        actual: 0,
        shorten: 0
    };
    var menuElement = document.getElementById('topmenuwrapper');
    var elementHeight = menuElement.offsetHeight;
    if (!isNil(menuElement)) {
        patch(patchElement('topmenuwrapper'), function () { });
        menuElement.style.top = "-" + (elementHeight + 1) + "px";
    }
};
export { topMenuKill, ScrollMenu };
//# sourceMappingURL=index.js.map